import Router from 'next/router'

export const redirect = (target, context) => {
  if (context.res) {
    if (context.res.writableEnded) return // prevent 500 from setting headers after response ended

    context.res.writeHead(303, { Location: target })
    context.res.end()
  } else {
    Router.replace(target)
  }
}

export default redirect
